import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// eslint-disable-next-line react/prefer-stateless-function
class UserDaysStatTable1Item extends Component {
  render() {
    return (
      <tr>
        <td className="cell-border">{this.props.item.groupDateDesc}</td>
        <td className="cell-border cell-border-left">
          {this.props.item.execCount}
        </td>
        <td
          className={
            this.props.item.execSum < 0
              ? 'text-nowrap text-danger'
              : 'text-nowrap text-success'
          }
        >
          {this.props.item.execSum > 0 ? '+' : ''}
          {this.props.item.execSum} <i className="fa fa-rub" />
        </td>
        <td className="cell-border cell-border-left">
          {this.props.item.taskCount}
        </td>
        <td
          className={
            this.props.item.taskSum < 0
              ? 'text-nowrap text-danger'
              : 'text-nowrap text-success'
          }
        >
          {this.props.item.taskSum > 0 ? '+' : ''}
          {this.props.item.taskSum} <i className="fa fa-rub" />
        </td>
        <td className="cell-border cell-border-left">
          {this.props.item.refRegCounter + this.props.item.ref2RegCounter}
        </td>
        <td
          className={
            this.props.item.refSum < 0
              ? 'text-nowrap text-danger'
              : 'text-nowrap text-success'
          }
        >
          {this.props.item.refSum > 0 ? '+' : ''}
          {this.props.item.refSum} <i className="fa fa-rub" />
        </td>
        <td className="cell-border cell-border-left text-nowrap">
          <strong>
            {this.props.item.balance} <i className="fa fa-rub" />
          </strong>
        </td>
      </tr>
    );
  }
}

UserDaysStatTable1Item.propTypes = {
  item: PropTypes.shape({
    groupDateDesc: PropTypes.string.isRequired,
    execCount: PropTypes.number.isRequired,
    execSum: PropTypes.string.isRequired,
    taskCount: PropTypes.number.isRequired,
    taskSum: PropTypes.string.isRequired,
    refRegCounter: PropTypes.number.isRequired,
    ref2RegCounter: PropTypes.number.isRequired,
    refSum: PropTypes.string.isRequired,
    balance: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(UserDaysStatTable1Item);



// WEBPACK FOOTER //
// ./src/components/UserDaysStat/UserDaysStatTables/UserDaysStatTable1/UserDaysStatTable1Item.js